import { CreatePromotionCode } from './CreatePromotionCode'
import { withCreatePromotionCode } from './withCreatePromotionCode'

const ConnectedCreatePromotionCode =
  withCreatePromotionCode(CreatePromotionCode)

export { ConnectedCreatePromotionCode as CreatePromotionCode }
